<template>
    <table-layout title="مدیریت تخفیف ها">
        <template #buttons>           
            <router-link :to="{ name: 'Offer' }">
                <b-button pill variant="purple"> بازگشت </b-button>
            </router-link>
        </template>

        <template #table>
            <offer-items :items="trash"></offer-items>
        </template>

        <div class="row pt-3">
            <div class="mt-3 color">
                <pagination :meta="meta" :on-change-page="changePage" />
            </div>
        </div>
    </table-layout>            
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import TableLayout from '../TableLayout'
import Pagination from "../Pagination"
import OfferItems from "./Items"


export default {
    name: "OfferTrash",
    components: {TableLayout, Pagination, OfferItems},

    data() {
        return {
            
        }
    },
    computed: {
        ...mapGetters({
            trash: "Offer/getTrash",
            meta: "Offer/getPaginationMeta",
            links: "Offer/getPaginationLinks",
        }),
    },
    methods: {
        ...mapActions({
            getTrash: "Offer/getTrash",
        }),
        changePage(page) {
            this.getTrash(page)
        },
    },
    mounted() {
        this.getTrash()
    },
}
</script>

<style scoped>

</style>